const GOOGLE_SCRIPT_URL =
  'https://script.google.com/macros/s/AKfycbyvZAIrnVx-xo6H8Jp3LHYqTTPgR5XEPiVhuVA-C5HCejrFGT6rglDKFNnRNBZM7m2D/exec';

export function getFilestackFileData(result) {
  if (!result) return null;

  if (result.success) {
    return result.success;
  }

  if (result.filesUploaded && result.filesUploaded.length > 0) {
    return result.filesUploaded[0];
  }

  if (result.handle) {
    return result;
  }

  return null;
}

//sheet id 1aGG4gk7mZfmTKNmFdeuy7wUABayY7P4K62w9LHGuxfc

export async function logFilestackUpload(fileData) {
  try {
    await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        handle: fileData.handle,
        url: fileData.url,
        filename: fileData.filename,
        mimetype: fileData.mimetype,
        size: fileData.size,
      }),
    });

    console.log('Upload logged to Google Sheet');
  } catch (error) {
    console.error('Could not log upload:', error);
  }
}
